import React, { FC } from 'react';
import { formatDate } from '../../../helpers/formatting/formatting';
import IArticlePageViewModel from '../../../interfaces/articlePage/articlePageViewModel';
import { ArticleStyledRichText } from '../../base/articleRichTextStyleWrapper/articleRichTextStyleWrapper';
import TextLinkWithArrowReverse from '../../textLinkWithArrowReverse';
import * as StyledArticleContent from './articleContent.styles';

interface Props {
	page: IArticlePageViewModel;
}

const ArticleContent: FC<Props> = ({ page }) => {
	const parts = page.Url.split('/');
	const beforeThirdSlash = parts.slice(0, 4).join('/');

	return (
		<>
			<StyledArticleContent.ComponentWrapper>
				<StyledArticleContent.ArticleDate>
					{formatDate(page.Values.ArticleDate)}
				</StyledArticleContent.ArticleDate>
				<StyledArticleContent.ArticleTitle>
					{page.Values.ArticleTitle || page.Name}
				</StyledArticleContent.ArticleTitle>
				{page.Values.ArticleAuthor && (
					<StyledArticleContent.ArticleAuthorWrapper>
						{page.Values.ArticleAuthor?.Values?.AuthorImage?.Src && (
							<StyledArticleContent.ArticleAuthorImage
								image={page.Values.ArticleAuthor?.Values?.AuthorImage?.Src}
							/>
						)}
						<StyledArticleContent.ArticleAuthorContent>
							<StyledArticleContent.ArticleAuthorName>
								{page.Values.ArticleAuthor.Values.AuthorName || page.Values.ArticleAuthor.Name}
							</StyledArticleContent.ArticleAuthorName>
							{page.Values.ArticleAuthor.Values.AuthorTitle && (
								<StyledArticleContent.ArticleAuthorTitle>
									{page.Values.ArticleAuthor.Values.AuthorTitle}
								</StyledArticleContent.ArticleAuthorTitle>
							)}
						</StyledArticleContent.ArticleAuthorContent>
					</StyledArticleContent.ArticleAuthorWrapper>
				)}
				<StyledArticleContent.ContentWrapper>
					<StyledArticleContent.ContentColumn>
						<StyledArticleContent.TagList>
							{page.Values.Tags && page.Values.Tags.map(tag => `#${tag} `)}
						</StyledArticleContent.TagList>
						<StyledArticleContent.ArticleSummary>
							{page.Values.ArticleSummary}
						</StyledArticleContent.ArticleSummary>

						<img src={page.Values.ArticleImage.Src} alt={`${page.Values.ArticleImage.Name}`}></img>
						<p>{page.Values.ArticleImage.Caption}</p>

						<StyledArticleContent.ArticleContent>
							<ArticleStyledRichText content={page.Values.ArticleContent} />
						</StyledArticleContent.ArticleContent>
					</StyledArticleContent.ContentColumn>
				</StyledArticleContent.ContentWrapper>
			</StyledArticleContent.ComponentWrapper>
			<StyledArticleContent.LinkContainer>
				<TextLinkWithArrowReverse
					href={beforeThirdSlash}
					title={parts[2] === 'news' ? 'News' : 'Allar fréttir'}
				/>
			</StyledArticleContent.LinkContainer>
		</>
	);
};

export default ArticleContent;
